<template>
    <div>
        <v-app>
            <v-card elevation="2" outlined class="p-3">
                <div class="row">
                    <div class="col-md-12 p-5">
                        <v-toolbar flat>
                            <v-tabs v-model="tab" align-with-title grow>
                                <v-tabs-slider/>
                                <v-tab v-for="item in lists">
                                    {{ item.name }}
                                </v-tab>
                            </v-tabs>
                        </v-toolbar>
                        <v-tabs-items v-model="tab">
                            <v-tab-item v-for="item in lists">
                                <iframe :src="item.pdf" width="100%" class="my-10" style="position: relative"
                                        height="500px" :key="item.value"></iframe>
                                <div class="mx-auto col-md-6 text-center mt-5">
                                    <v-fab-transition>
                                        <v-btn
                                                key="mdi-pencil"
                                                :key="item.value"
                                                large
                                                class="mx-auto  position-absolute btn-download font-weight-bold text-center"
                                                bottom
                                                style="z-index: 9999;right:0;left:0;bottom: 4.5rem"
                                                left
                                                :href="item.pdf"
                                                download
                                        >
                                            <v-icon>mdi-download</v-icon>
                                            دانلود فایل پی دی اف
                                        </v-btn>
                                    </v-fab-transition>
                                </div>
                            </v-tab-item>
                        </v-tabs-items>
                    </div>
                </div>
            </v-card>
        </v-app>
    </div>
</template>

<script>
import PayPage from "../site/payPage";
import button from "../../content/button";

export default {
    name: "list",
    components: {PayPage},
    data() {
        return {
            tab: 0,
            lists: [
                {name: 'تعرفه طراحی سایت', value: 'design', pdf: '/assets/file/price.pdf'},
                {name: 'تعرفه سئو سایت', value: 'seo', pdf: '/assets/file/price.pdf'},
                {name: 'تعرفه پشتیبانی سایت', value: 'support', pdf: '/assets/file/price.pdf'},
            ]
        }
    },
}
</script>

<style scoped>

</style>